module.exports = __webpack_public_path__ + "img/logout.50b67eb9.svg";